import { render } from "./Applicant.vue?vue&type=template&id=6f197f7d"
import script from "./Applicant.vue?vue&type=script&lang=js"
export * from "./Applicant.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__